import { render, staticRenderFns } from "./LastActivity.vue?vue&type=template&id=63cf270f"
import script from "./LastActivity.vue?vue&type=script&lang=js"
export * from "./LastActivity.vue?vue&type=script&lang=js"
import style0 from "./LastActivity.vue?vue&type=style&index=0&id=63cf270f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports